import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import '../src/assets/scss/app.scss';
import { initializeApplicationInsights } from './lib/applicationInsights';
import { logger } from './lib/logger';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

// Initialize telemetry before anything renders so the first page view + early errors are captured.
initializeApplicationInsights();

// Capture errors React's ErrorBoundary can't see (async / outside the render tree).
window.addEventListener('unhandledrejection', (e) => {
  logger.error(e.reason, { source: 'unhandledrejection' });
});
window.addEventListener('error', (e) => {
  logger.error(e.error ?? e.message, { source: 'window.error' });
});

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
